module.exports = __webpack_public_path__ + "static/media/LY.32915a89.png";